
import {ADDRESS_UPDATE_REQUEST, ADDRESS_UPDATE_SUCCESS, ADDRESS_UPDATE_FAILURE } from './actionTypes';
import {ADDRESS_ADD_REQUEST, ADDRESS_ADD_SUCCESS, ADDRESS_ADD_FAILURE } from './actionTypes';
import {ADDRESS_DELETE_REQUEST, ADDRESS_DELETE_SUCCESS, ADDRESS_DELETE_FAILURE } from './actionTypes';
import {COMPANY_ADD_REQUEST, COMPANY_ADD_SUCCESS,COMPANY_ADD_FAILURE } from './actionTypes';
import {COMPANY_GET_REQUEST, COMPANY_GET_SUCCESS, COMPANY_GET_FAILURE } from './actionTypes';
import {COMPANY_UPDATE_REQUEST, COMPANY_UPDATE_SUCCESS, COMPANY_UPDATE_FAILURE } from './actionTypes';
import { ADDRESS_REQUEST, ADDRESS_SUCCESS, ADDRESS_FAILURE } from './actionTypes';
import authService from '../../services/companyService';



export const addressUpdateRequest = () => ({
  type: ADDRESS_UPDATE_REQUEST,
});

export const addressUpdateSuccess = (user) => ({
  type: ADDRESS_UPDATE_SUCCESS,
  payload: user,
});

export const addressUpdateFailure = (error) => ({
  type: ADDRESS_UPDATE_FAILURE,
  payload: error,
});
export const UpdateAddress = (data,token) => {

  return async (dispatch) => {
    dispatch(addressUpdateRequest());
    try {
      const response = await authService.updateAddress(data,token);
      dispatch(addressUpdateSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(addressUpdateFailure(error.response?.data || 'adres alınamadı!'));
      throw error;
    }
  };
};

// adres bilgilerini çeker
export const addressRequest = () => ({
  type: ADDRESS_REQUEST,
});

export const addressSuccess = (user) => ({
  type: ADDRESS_SUCCESS,
  payload: user,
});

export const addressFailure = (error) => ({
  type: ADDRESS_FAILURE,
  payload: error,
});

export const GetAddress = (id,token) => {
  return async (dispatch) => {
    dispatch(addressRequest());
    try {
      const response = await authService.getAddress(id,token);
      dispatch(addressSuccess(response.data.data));
      return response.data.data;
    } catch (error) {
      dispatch(addressFailure(error.response?.data || 'adres alınamadı!'));
      throw error;
    }
  };
};


export const addAddressRequest = () => ({
  type: ADDRESS_ADD_REQUEST,
});

export const addAddressSuccess = (user) => ({
  type: ADDRESS_ADD_SUCCESS,
  payload: user,
});

export const addAddressFailure = (error) => ({
  type: ADDRESS_ADD_FAILURE,
  payload: error,
});

export const addAddress = (formData,token) => {
  return async (dispatch) => {
    dispatch(addAddressRequest());
    try {
      const response = await authService.addAddress(formData,token);  
    
      dispatch(addAddressSuccess(response.data));
    } catch (error) {
      dispatch(addAddressFailure(error.response.data || 'addres ekelenemedi!'));
    }
  };
};



export const companyAddRequest = () => ({
    type: COMPANY_ADD_REQUEST,
  });
  
  export const companyAddSuccess = (user) => ({
    type: COMPANY_ADD_SUCCESS,
    payload: user,
  });
  
  export const companyAddFailure = (error) => ({
    type: COMPANY_ADD_FAILURE,
    payload: error,
  });
  export const addCompany = (data,token) => {
  
    return async (dispatch) => {
      dispatch(companyAddRequest());
      try {
        const response = await authService.addCompany(data,token);
        dispatch(companyAddSuccess(response.data));
        return response.data;
      } catch (error) {
        dispatch(companyAddFailure(error.response?.data || 'mağza eklenemedi!'));
        throw error;
      }
    };
  };


  // mağza bilgilerini çeker
export const companyGetRequest = () => ({
    type: COMPANY_GET_REQUEST,
  });
  
  export const companyGetSuccess = (user) => ({
    type: COMPANY_GET_SUCCESS,
    payload: user,
  });
  
  export const companyGetFailure = (error) => ({
    type: COMPANY_GET_FAILURE,
    payload: error,
  });
  
  export const GetCompanyAction = (id,token) => {
  
    return async (dispatch) => {
      dispatch(companyGetRequest());
      try {
        const response = await authService.getCompany(id,token);
        dispatch(companyGetSuccess(response.data.data));
        return response.data.data;
      } catch (error) {
        dispatch(companyGetFailure(error.response?.data || 'mağza alınamadı!'));
        throw error;
      }
    };
  };


  export const companyUpdateRequest = () => ({
    type:COMPANY_UPDATE_REQUEST,
  });
  
  export const companyUpdateSuccess = (user) => ({
    type: COMPANY_UPDATE_SUCCESS,
    payload: user,
  });
  
  export const companyUpdateFailure = (error) => ({
    type: COMPANY_UPDATE_FAILURE,
    payload: error,
  });

  export const CompanyUpdate = (data,token) => {
  
    return async (dispatch) => {
      dispatch(companyUpdateRequest());
      try {
        const response = await authService.companyUpdateApi(data,token);
        dispatch(companyUpdateSuccess(response.data));
        return response.data;
      } catch (error) {
        dispatch(companyUpdateFailure(error.response?.data || 'mağza eklenemedi!'));
        throw error;
      }
    };
  };


    // adres bilgilerini sil
export const deleteAddressRequest = () => ({
  type: ADDRESS_DELETE_REQUEST,
});

export const deleteAddressSuccess = (user) => ({
  type: ADDRESS_DELETE_SUCCESS,
  payload: user,
});

export const deleteAddressFailure = (error) => ({
  type: ADDRESS_DELETE_FAILURE,
  payload: error,
});

export const deleteAddres = (id,token) => {

  return async (dispatch) => {
    dispatch(deleteAddressRequest());
    try {
      const response = await authService.addresDeleteApi(id,token);
      dispatch(deleteAddressSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(deleteAddressFailure(error.response?.data || 'mağza silinemedi!'));
      throw error;
    }
  };
};



  
